/**
 * 自社テナント検索
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/tenants`
 
 const search_tenant = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     /**
      * テナント一覧の取得.
      * ドロップダウンで表示可能な内容を返します.
      * @return {Promise<unknown>}
      */
      index () {
        return new Promise((resolve) => {
          Vue.$http.get(API_PATH).then(data => {
            resolve(data.content)
          })
        })
      },
     /**
      * テナント情報の取得.
      * @param commit
      * @param { Number } id テナントのID
      * @return {Promise<unknown>}
      */
     show ({ commit }, { id }) {
       const api_path = `${API_PATH}/${id}`
       return new Promise((resolve) => {
         Vue.$http.get(api_path).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default search_tenant
 